import Vue from "vue";
import VueRouter from "vue-router";
import LandingPage from "../views/LandingPage.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "landingPage",
    beforeEnter(to, from, next) {
      setTimeout(() => next(), 100);
    },
    component: LandingPage
  },
  {
    path: "/scenarios",
    name: "scenarios",
    component: () =>
      import(
        /* webpackChunkName: "scenarioPage" */ "../views/ScenariosPage.vue"
      )
  },
  {
    // will match everything, status 404
    path: '/*',
    redirect: "/"
  }
];

const router = new VueRouter({
  base:
    process.env.NODE_ENV === "production"
      ? process.env.VUE_APP_PROD_BASE_PATH
      : process.env.VUE_APP_DEV_BASE_PATH,
  mode: "history",
  routes
});

export default router;
